export default __webpack_public_path__ + "static/media/arrow-down.3d99ddd5.svg";